import Svg, { Path } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const IconArrowNext = ({ width = 16, height = 16, color = '#fff' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="m14.473 7.527-4-4a.67.67 0 1 0-.946.946l2.866 2.86H2a.667.667 0 1 0 0 1.334h10.393l-2.866 2.86a.667.667 0 0 0 .217 1.092.666.666 0 0 0 .73-.146l4-4a.666.666 0 0 0 0-.946Z"
    />
  </Svg>
)
export default IconArrowNext
